import { TextField } from '@origin-digital/style-guide';
import React from 'react';

import analytics from '../../../../analytics';
import logger from '../../../../logging';
import { isPostcodeFieldTouched } from '../../../../utils/formHelpers';

import { PostcodeFieldProps } from './PostcodeField.types';
import {
  SolarServiceabilityOptions,
  SolarProduct,
  RepairServiceabilityOptions
} from '../../../../../__generated__/globalTypes';

class PostcodeField extends React.Component<PostcodeFieldProps> {
  constructor(props: PostcodeFieldProps) {
    super(props);

    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.getValues = this.getValues.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleAnalyticsOnClick = this.handleAnalyticsOnClick.bind(this);
  }

  componentDidMount() {
    const { form, field } = this.props;

    if (form.values[field.name]) {
      this.handleOnBlur(undefined);
    }
  }

  handleOnBlur = async (event: React.ChangeEvent<HTMLInputElement> | undefined) => {
    const { form, field, productType, graphQuery, addressCheckHandler } = this.props;
    const postcode = event ? event.target.value : field.value;

    form.setFieldTouched(field.name, true, true);

    if (postcode && postcode.length === 4) {
      try {
        const { data }: any = await addressCheckHandler(
          graphQuery,
          this.getValues(postcode, productType)
        );

        if (data) {
          const { form, field, changeHandler, parseGraphResult } = this.props;
          const checkType = data.checkServiceability
            ? data.checkServiceability
            : data.checkRepairServiceability;
          const serviceable = parseGraphResult(checkType);

          form.setFieldValue('hiddenPostcode', serviceable.toString(), true);
          form.setFieldTouched('hiddenPostcode', true, true);
          form.setFieldValue(field.name, postcode, false);
          form.setFieldValue('address', postcode, false);

          changeHandler({ [field.name]: postcode, address: postcode });
        }
      } catch (error) {
        logger.error('GraphQL Error', error);
        return;
      }
    }
  };

  getValues = (
    value: string,
    productType: SolarProduct
  ): SolarServiceabilityOptions | RepairServiceabilityOptions => {
    return {
      productType: productType,
      address: {
        postcode: value
      }
    };
  };

  handleOnChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { form, field, changeHandler } = this.props;

    if (event.currentTarget.value.length < 4) {
      form.setFieldValue('hiddenPostcode', '', true);
    }

    if (event.currentTarget.value === '') {
      form.setFieldValue(field.name, '', false);
      form.setFieldValue('address', '', false);
      changeHandler({ [field.name]: '' });
    } else {
      form.setFieldValue(field.name, event.currentTarget.value, true);
      changeHandler({ [field.name]: event.currentTarget.value });
    }
  };

  handleAnalyticsOnClick = (): boolean | undefined => analytics.firstInteraction();

  render() {
    const { field, label, form, transform, maxLength, validating, isDisqualified } = this.props;

    const error = isDisqualified && field.value.length === 4 ? ' ' : form.errors[field.name];

    return (
      <TextField
        data-lpignore={true}
        label={label}
        name={field.name}
        value={field.value}
        //@ts-ignore
        touched={isPostcodeFieldTouched(form, field.name)}
        //@ts-ignore
        error={error}
        spinner={validating}
        transform={transform}
        maxLength={maxLength}
        showCharacterCount
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => this.handleOnChange(event)}
        onBlur={(event: React.ChangeEvent<HTMLInputElement>) => this.handleOnBlur(event)}
        onClick={this.handleAnalyticsOnClick}
      />
    );
  }
}

export { PostcodeField as default };
